module.exports = __webpack_public_path__ + "img/card_ip_stipulation15.e5965b3f.svg";